import { isSameDay } from 'date-fns';
import { useIntl } from 'react-intl';
import { IconEye } from '@rossum/ui/icons/tabler';
import {
  ActivityRowLayout,
  formatActivityTimestamp,
  RowIcon,
  RowLabel,
  RowValue,
} from '../../core';

type OpenedRowProps = {
  openedAt: string;
  closedAt: string | null;
};

export const OpenedRow = ({ openedAt, closedAt }: OpenedRowProps) => {
  const intl = useIntl();
  const formatTime = (value: string) =>
    intl.formatTime(value, { timeStyle: 'short' });
  const formatClosed = (closed: string) =>
    isSameDay(new Date(openedAt), new Date(closed))
      ? formatTime(closed)
      : formatActivityTimestamp(intl, closed);

  return (
    <ActivityRowLayout
      dataCy="document-history-opened-row"
      label={
        <RowLabel
          label={intl.formatMessage({
            id: 'features.documentHistory.field.opened',
          })}
        />
      }
      labelIcon={<RowIcon icon={IconEye} />}
      value={
        <RowValue
          value={
            closedAt
              ? intl.formatMessage(
                  { id: 'features.documentHistory.field.openedRange' },
                  {
                    openedAt: formatTime(openedAt),
                    closedAt: formatClosed(closedAt),
                  }
                )
              : formatTime(openedAt)
          }
        />
      }
    />
  );
};
